import { AriaOrb } from "@/components/AriaOrb";

const STATUS = {
  listening: "Escuchando...",
  processing: "Procesando consulta...",
  speaking: "Respondiendo...",
  idle: "En espera de instrucciones",
};

export const AssistantView = ({ orbState, messages }) => (
  <>
    <AriaOrb state={orbState} size={300} />
    <p className="font-mono text-sm tracking-[0.2em] uppercase text-cyan-400/80 mt-8 text-glow">
      {STATUS[orbState] || STATUS.idle}
    </p>
    {messages.length > 0 && (
      <p className="max-w-2xl text-center text-cyan-50 font-light mt-6 leading-relaxed">
        {messages[messages.length - 1].content}
      </p>
    )}
  </>
);
